import React from 'react';
import ToggleRow from './ToggleRow';

const PaymentSettingsCard = ({ settings, onToggle }) => (
  <div className="bg-white rounded-xl shadow p-6">
    <h3 className="font-semibold mb-1">支付方式</h3>
    <p className="text-sm text-gray-500 mb-4">关闭的支付方式将不会在 H5 端展示给客户</p>
    <div className="space-y-4">
      <ToggleRow
        label="KHQR"
        description="扫码支付，收款到银行账户"
        checked={!!settings.enable_khqr}
        onToggle={() => onToggle('enable_khqr')}
      />
      <ToggleRow
        label="支付寶（KHR）"
        description="扫码支付，按汇率折算瑞尔收款；超过限额自动隐藏"
        checked={!!settings.enable_alipay}
        onToggle={() => onToggle('enable_alipay')}
        bordered
      />
      <ToggleRow
        label="USDT"
        description="加密货币转账支付"
        checked={!!settings.enable_usdt}
        onToggle={() => onToggle('enable_usdt')}
        bordered
      />
      <ToggleRow
        label="貨到付款"
        description="配送/自提时现场收款"
        checked={!!settings.enable_cod}
        onToggle={() => onToggle('enable_cod')}
        bordered
      />
    </div>
  </div>
);

export default PaymentSettingsCard;